"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const Globals = require('../../globals');
const disableIntegrations = originalIntegrations => {
  const integrations = _objectSpread({}, originalIntegrations);
  for (const integration in integrations) {
    integrations[integration] = false;
  }
  integrations['Segment.io'] = true;
  integrations['Repeater'] = true;
  return integrations;
};
const sendIdentifiesWithIds = (id, hashedId, callbackData) => {
  const context = {
    integrations: disableIntegrations(callbackData.integrations),
    externalIds: [{
      id: hashedId,
      type: callbackData.idType + 'Hashed',
      collection: 'users'
    }]
  };
  if (callbackData.idType === 'anonymousId') {
    context.anonymousId = id;
  }
  const tracking = Globals.getTracking();
  tracking.identify(callbackData.idType === 'userId' ? id : undefined, {}, context);
};
const getIdFromAnalytics = idType => {
  const normalizedIdType = idType === 'userId' ? 'id' : idType;
  const user = window.analytics && typeof window.analytics.user === 'function' ? window.analytics.user() : undefined;
  if (user && typeof window.analytics.user()[normalizedIdType] === 'function') {
    return window.analytics.user()[normalizedIdType]();
  }
  return undefined;
};
module.exports = {
  disableIntegrations,
  sendIdentifiesWithIds,
  getIdFromAnalytics
};